export default "__VITE_ASSET__eNNgILnV__"